import React, { Component } from "react";
import PropTypes from "prop-types";
import classnames from "classnames";

/**
 * Components/Grid/Col
 * ----------------------------------------------------------------------
 * Coluna para uso com o grid do framework, compatível com Bootstrap 4.
 * 
 * @param {*} props 
 *     Objeto com propriedades do componente, como id, classe, children ou 
 *     breakpoints mobile 
 */
export class Col extends Component {
  render () {
    const { props } = this;

    return (
      <div
        id={props.id}
        className={classnames(this.setClassItem(), props.className)}>
        {props.children }
      </div>
    );
  }

  // --------------------------------------------------------------------

  /**
   * Verifica atributo de order.
   *
   * @param {String|Number} order
   *     Número ou string representando ordem CSS
   * @returns {number}
   */
  checkOrder = (order) => {
    if (typeof order === "number") {
      order = Math.max(1, Math.min(order, 12));
    } else {
      order = parseInt(order);
      order = (isNaN(order))
        ? 1
        : Math.max(1, Math.min(order, 12));
    }

    return order;
  };

  /**
   * Define classes de coluna para um `value` e `breakpoint`.
   * 
   * @param {*} value 
   *     Valor para definição da classe, podendo ser string, número e/ou 
   *     objeto 
   * @param {String} breakpoint 
   *     Opcional, define um modificador de breakpoint
   * @returns {String}
   */
  setColumnSizeClass = (value, breakpoint) => {
    if (typeof value === "number") {
      value = Math.max(1, Math.min(value, 12));

      return (breakpoint === "xs") 
        ? `col-${value}` 
        : `col-${breakpoint}-${value}`;
    } else if (typeof value === "string") {
      value = parseInt(value);
      value = (isNaN(value)) 
        ? null 
        : Math.max(1, Math.min(parseInt(value), 12));
      
      if (breakpoint === "xs") {
        return (value === "null") 
          ? `col` 
          : `col-${value}`;
      } else {
        return (value === "null") 
          ? `col-${breakpoint}` 
          : `col-${breakpoint}-${value}`;
      }
    } else {
      return (breakpoint === "xs") 
        ? `col-auto` 
        : `col-${breakpoint}-auto`;
    }
  };

  /**
   * Define classes do componente.
   *
   * @returns {String[]}
   */
  setClassItem = () => {
    const { props } = this;

    let breakpoints = ["xs", "sm", "md", "lg", "xl"],
        classes = ["col"],
        order;

    for (let n = 0; n < breakpoints.length; n++) {
      let current = props[breakpoints[n]];

      if (current === undefined || current === null) continue;

      if (
        typeof current === "number" 
        || typeof current === "string" 
        || typeof current === "boolean" 
      ) {
        classes.push(
          this.setColumnSizeClass(current, breakpoints[n])
        );
      } else  {
        if (current.hasOwnProperty("size")) {
          classes.push(
            this.setColumnSizeClass(current.size, breakpoints[n])
          );
        }

        if (current.hasOwnProperty("order")) {
          order = this.checkOrder(current.order);

          classes.push(
            (breakpoints[n] === "xs")
              ? `order-${order}`
              : `order-${breakpoints[n]}-${order}`
          );
        }
      }
    }

    // Pq tem um order separado? Fabio, você bebeu? :(
    if (props.order) {
      let mainOrder = this.checkOrder(props.order);

      if (!classes.includes(`order-${order}`)) {
        classes.push(`order-${order}`);
      }
    }

    return classes;
  };
}

// ----------------------------------------------------------------------

const stringOrNumberProp = PropTypes.oneOfType([
  PropTypes.string,
  PropTypes.number 
]);

const columnProp = PropTypes.oneOfType([
  PropTypes.string,
  PropTypes.number,
  PropTypes.bool,
  PropTypes.shape({
    size: PropTypes.oneOfType([
      PropTypes.bool,
      PropTypes.number,
      PropTypes.string
    ]),
    order: stringOrNumberProp
  })
]);

Col.defaultProps = {
  className: "",
  children: null,
  xs: null,
  sm: null,
  md: null,
  lg: null,
  xl: null,
  order: null
};

Col.propTypes = {
  id: PropTypes.string,
  className: PropTypes.oneOfType([
    PropTypes.string,
    PropTypes.arrayOf(PropTypes.string)
  ]),
  children: PropTypes.node,
  xs: columnProp,
  sm: columnProp,
  md: columnProp,
  lg: columnProp,
  xl: columnProp,
  order: stringOrNumberProp
};
